<template>
  <div>
    <v-card class="my-2">
      <v-row class="px-2 mb-2">
        <v-col class="py-2" cols="12" sm="12" md="3" xs="12">
          <v-select v-model="filters.account" :error="accountError" :items="accounts.data" :loading="loadingAccounts"
            item-text="account_name" item-value="name" menu-props="auto" label="Conta" hide-details single-line solo
            color="primary" dense></v-select>
        </v-col>
        <v-col class="py-2" cols="12" sm="12" md="3" xs="12">
          <v-autocomplete autocomplete="off" v-model="filters.location" :error="locationError" :items="locations.data"
            :loading="loadingLocations" v-on:keyup="onLocationKeyUp" item-text="location_name_code" item-value="name"
            menu-props="auto" label="Local ou Id" hide-details single-line solo color="primary" dense></v-autocomplete>
        </v-col>
        <v-col class="py-2" cols="12" sm="4" md="2" xs="12">
          <v-select :items="starRatingOptions" v-model="filters.star_rating" item-text="text" item-value="id"
            menu-props="auto" label="Estrelas" hide-details single-line solo multiple clearable color="primary"
            dense></v-select>
        </v-col>
        <v-col class="py-2" cols="12" sm="4" md="2" xs="12">
          <v-select :items="replyOptions" v-model="filters.with_reply" item-text="text" item-value="id" menu-props="auto"
            label="Resposta" hide-details single-line solo color="primary" dense clearable></v-select>
        </v-col>
        <v-col class="py-2" cols="12" sm="4" md="2" xs="12">
          <v-select :items="commentOptions" v-model="filters.with_comment" item-text="text" item-value="id"
            menu-props="auto" label="Comentário" hide-details single-line solo color="primary" dense clearable></v-select>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div v-show="moreFilters">
          <v-row class="px-2">
            <v-col class="py-2" cols="12" sm="4" md="2" xs="12">
              <date-picker solo hide-details clearable label="De" noIcon dense v-on:change="changeSchedulingDateStart" />
            </v-col>
            <v-col class="py-2" cols="12" sm="4" md="2" xs="12">
              <date-picker solo hide-details clearable label="Até" noIcon dense :min="filters.date_start"
                v-on:change="changeSchedulingDateEnd" />
            </v-col>
            <v-col class="py-2" cols="12" sm="12" md="2" xs="12">
              <v-autocomplete autocomplete="off" v-on:keyup="onStateKeyUp" v-model="filters.states" :error="stateError"
                :items="states.data" :loading="loadingStates" item-text="administrative_area"
                item-value="administrative_area" menu-props="auto" label="Estado" hide-details single-line multiple
                clearable solo color="primary" dense></v-autocomplete>
            </v-col>
            <v-col class="py-2" cols="12" sm="12" md="3" xs="12">
              <v-autocomplete autocomplete="off" v-model="filters.city" :error="cityError" :items="cities.data"
                :loading="loadingCities" v-on:keyup="onCityKeyUp" item-text="locality" item-value="locality"
                menu-props="auto" label="Cidade" hide-details single-line solo clearable color="primary"
                dense></v-autocomplete>
            </v-col>
            <v-col class="py-2" cols="12" sm="12" md="3" xs="12">
              <v-autocomplete autocomplete="off" v-on:keyup="onAddressKeyUp" v-model="filters.address"
                :error="addressError" :items="addresses.data" :loading="loadingAddress" item-text="address_line_one"
                item-value="address_line_one" menu-props="auto" label="Endereço" hide-details single-line solo clearable
                color="primary" dense></v-autocomplete>
            </v-col>
          </v-row>

          <v-row class="px-2">
            <v-col class="py-2" cols="12" sm="12" md="3" xs="12">
              <v-autocomplete autocomplete="off" v-on:keyup="onKeywordKeyUp" v-model="filters.keywords"
                :error="keywordsError" :items="keywords.data" :loading="loadingKeywords" item-text="name" item-value="id"
                menu-props="auto" label="Tags" color="primary" hide-details single-line solo dense multiple
                clearable></v-autocomplete>
            </v-col>
            <v-col class="py-2" cols="12" sm="4" md="3" xs="12">
              <v-select :items="orderDateOptions" v-model="filters.sort_by_date" item-text="text" item-value="id"
                menu-props="auto" label="Ordenar por data" hide-details single-line solo color="primary" dense
                clearable></v-select>
            </v-col>
            <v-col class="py-2" cols="12" sm="4" md="3" xs="12">
              <v-select :items="orderStarRatingOptions" v-model="filters.sort_by_stars" item-text="text" item-value="id"
                menu-props="auto" label="Ordenar por estrelas" hide-details single-line solo color="primary" dense
                clearable></v-select>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>

      <v-card-actions class="mt-4">
        <v-btn small outlined color="primary" @click="moreFilters = !moreFilters">
          <v-icon left>{{ moreFilters ? 'mdi-filter-minus-outline' : 'mdi-filter-plus-outline' }}</v-icon>
          {{ moreFilters ? 'Menos' : 'Mais' }} filtros
        </v-btn>
        <v-btn small outlined color="primary" @click="clearFilters">
          <v-icon left>mdi-filter-off-outline</v-icon>
          Limpar filtros
        </v-btn>
        <v-btn small :loading="loading" color="primary" @click="applyFilters">
          <v-icon left>mdi-filter</v-icon>
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>

    <div id="reviews-target"></div>
    <v-checkbox
      v-model="selectAll"
      label="Selecionar Todos"
      @change="toggleSelectAll"
    />
    <div v-if="loadingSkeleton">
      <v-skeleton-loader class="mb-2" v-for="item in 10" :key="item" elevation="2"
        type="article, actions"></v-skeleton-loader>
    </div>
    <div v-else>
      <card-review-pending v-for="review in (reviews && reviews.data ? reviews.data : [])" :key="review.id" :review="review" :on-ignored="onReviewIgnored"
        :on-replied="onReviewReplied" :on-review-updated="onReviewUpdated" :on-approved="onReviewApproved"
        :on-disapproved="onReviewDisapproved" />
    </div>
    <v-btn color="success" :disabled="$store.state.reviews.selectedReviews.length === 0" @click="approveSelectedReviews">
      Aprovar Selecionados ({{ $store.state.reviews.selectedReviews.length }})
    </v-btn>
    <v-btn color="error" :disabled="$store.state.reviews.selectedReviews.length === 0" @click="disapproveSelectedReviews">
      Desaprovar Selecionadas ({{ $store.state.reviews.selectedReviews.length }})
    </v-btn>
    <v-row class="pa-4">
      <v-spacer />
      <v-btn :disabled="page === 1" icon elevation="2" class="mr-1" @click="previousPage">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn 
        :disabled="!(reviews && reviews.data) || reviews.data.length < limit" 
        icon elevation="2" class="ml-1"
        @click="nextPage"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-spacer />
    </v-row>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import { handleResponseError } from '@/api/handleError'
import DatePicker from '@/components/DatePicker'
import CardReviewPending from '@/views/Reviews/CardReviewPending'

export default {
  name: 'ReviewsPending',
  computed: {
    ...mapState({
      reviews: state => state.reviews.pendingReviews,
      accounts: state => state.accounts.all,
      locations: state => state.locations.all,
      cities: state => state.locations.cities,
      states: state => state.locations.states,
      addresses: state => state.locations.addresses,
      keywords: state => state.keywords.all,
      selectedReviews: state => state.reviews.selectedReviews,
    }),
    _() {
      return _
    }
  },
  components: {
    DatePicker,
    CardReviewPending
  },
  methods: {
    fetchReviews: async function (scroll) {
      this.loading = true
      await this.$store.dispatch('reviews/getPendingReviews', {
        account: this.filters.account,
        location: this.filters.location,
        state: this.filters.state,
        city: this.filters.city,
        address: this.filters.address,
        stars: this.filters.star_rating,
        keywords: this.filters.keywords,
        date_start: this.filters.date_start,
        date_end: this.filters.date_end,
        with_comment: this.filters.with_comment,
        with_reply: this.filters.with_reply,
        sort_by_stars: this.filters.sort_by_stars,
        sort_by_date: this.filters.sort_by_date,
        limit: this.limit,
        page: this.page,
        desc: true,
        sort: 'create_time'
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as avaliações.')
        this.showNotification(message, 'red darken-2')
        this.loading = false
      })
      this.loading = false
      this.loadingSkeleton = false

      if (scroll) this.toTop()
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.$store.commit('reviews/setSelectedReviews', this.reviews.data.map(review => review.id));
      } else {
        this.$store.commit('reviews/setSelectedReviews', []);
      }
    },
    approveSelectedReviews() {
      const payload = {
          ids: this.$store.state.reviews.selectedReviews,
          account: this.filters.account,
          allSelected: false
      };
      console.log("Manually Sending Payload:", JSON.stringify(payload, null, 2));
        this.$store.dispatch('reviews/approveBulk', { router: this.$router }).then(() => {
          this.$store.commit('reviews/clearSelectedReviews');
          this.showNotification("Avaliações aprovadas com sucesso!", "success");
      }).catch(() => {
          this.showNotification("Erro ao aprovar avaliações.", "red darken-2");
      });
    },
    disapproveSelectedReviews() {
      const payload = {
        ids: this.$store.state.reviews.selectedReviews,
        account: this.filters.account,
        allSelected: false
      };

      console.log("Manually Sending Payload for Disapproval:", JSON.stringify(payload, null, 2));

      this.$store.dispatch('reviews/disapproveBulk', { router: this.$router }).then(() => {
        this.$store.commit('reviews/clearSelectedReviews');
        this.showNotification("Avaliações desaprovadas com sucesso!", "success");
      }).catch(() => {
        this.showNotification("Erro ao desaprovar avaliações.", "red darken-2");
      });
    },
    fetchAccounts: async function () {
      this.loadingAccounts = true
      await this.$store.dispatch('accounts/getAccounts', { limit: 0 }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as contas.')
        this.showNotification(message, 'red darken-2')
        this.loadingAccounts = false
      })
      this.loadingAccounts = false
    },
    fetchLocations: async function () {
      if (!this.filters.account) return
      this.loadingLocations = true
      await this.$store.dispatch('locations/getLocations', {
        account: this.filters.account,
        search: this.searchLocation,
        limit: 100
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar os locais.')
        this.showNotification(message, 'red darken-2')
        this.loadingLocations = false
      })
      this.loadingLocations = false
    },
    fetchLocationStates: async function () {
      this.accountError = false
      if (!this.filters.account) {
        this.accountError = true
        return
      }

      this.loadingStates = true
      await this.$store.dispatch('locations/getStates', {
        limit: 100,
        search: this.searchState,
        account: this.filters.account
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar os estados.')
        this.showNotification(message, 'red darken-2')
        this.loadingAccounts = false
      })
      this.loadingStates = false
    },
    fetchLocationCities: async function () {
      this.accountError = false
      if (!this.filters.account) {
        this.accountError = true
        return
      }

      if (!Array.isArray(this.filters.states) || this.filters.states.length === 0) {
        return
      }

      this.loadingCities = true
      await this.$store.dispatch('locations/getCities', {
        limit: 200,
        search: this.searchCity,
        account: this.filters.account,
        states: this.filters.states
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as cidades.')
        this.showNotification(message, 'red darken-2')
        this.loadingCities = false
      })
      this.loadingCities = false
    },
    fetchLocationAddresses: async function () {
      this.accountError = false
      if (!this.filters.account) {
        this.accountError = true
        return
      }

      this.loadingAddress = true
      await this.$store.dispatch('locations/getAddresses', {
        limit: 200,
        search: this.searchAddress,
        account: this.filters.account
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar os endereços.')
        this.showNotification(message, 'red darken-2')
        this.loadingAddress = false
      })
      this.loadingAddress = false
    },
    fetchLocationKeywords: async function () {
      this.accountError = false
      if (!this.filters.account) {
        this.accountError = true
        return
      }

      this.loadingKeywords = true
      await this.$store.dispatch('keywords/getKeywords', {
        limit: 200,
        search: this.searchKeyword,
        account: this.filters.account
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar os endereços.')
        this.showNotification(message, 'red darken-2')
        this.loadingKeywords = false
      })
      this.loadingKeywords = false
    },
    applyFilters: function () {
      this.loadingSkeleton = true
      if (this.page === 1) {
        this.fetchReviews(true)
      } else {
        this.page = 1 // fetchReview called on watch:page
      }
    },
    changeSchedulingDateStart(date) {
      this.filters.date_start = date
    },
    changeSchedulingDateEnd(date) {
      this.filters.date_end = date
    },
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    onReviewIgnored: function () {
      this.fetchReviews()
      this.showNotification('Avaliação ignorada!', 'green')
    },
    onReviewReplied: function () {
      this.fetchReviews()
      this.showNotification('Avaliação respondida!', 'green')
    },
    onReviewUpdated: function () {
      this.fetchReviews()
      this.showNotification('Avaliação atualizada!', 'green')
    },
    onReviewApproved: function () {
      this.fetchReviews()
      this.showNotification('Avaliação aprovada!', 'green')
    },
    onReviewDisapproved: function () {
      this.fetchReviews()
      this.showNotification('Avaliação reprovada!', 'green')
    },
    nextPage: function () {
      this.page = this.page + 1
    },
    previousPage: function () {
      this.page = this.page - 1 > 0 ? this.page - 1 : 1
    },
    toTop() {
      this.$vuetify.goTo('#reviews-target')
    },
    clearFilters: function () {
      this.filters = {
        star_rating: [],
        account: null,
        location: null,
        date_start: '',
        date_end: '',
        status: '',
        with_comment: null,
        with_reply: null,
        sort_by_stars: null,
        sort_by_date: null,
        city: '',
        state: '',
        address: '',
        keywords: [],
      }
    },
    onLocationKeyUp: function () {
      clearTimeout(this.timeoutLocations)
      this.timeoutLocations = setTimeout(this.fetchLocations, 400)
    },
    onCityKeyUp: function () {
      clearTimeout(this.timeoutCities)
      this.timeoutCities = setTimeout(this.fetchLocationCities, 400)
    },
    onAddressKeyUp: function () {
      clearTimeout(this.timeoutAddress)
      this.timeoutAddress = setTimeout(this.fetchLocationAddresses, 400)
    },
    onKeywordKeyUp: function () {
      clearTimeout(this.timeoutAddress)
      this.timeoutAddress = setTimeout(this.fetchLocationKeywords, 400)
    },
    onStateKeyUp: function () {
      clearTimeout(this.timeoutStates)
      this.timeoutStates = setTimeout(this.fetchLocationStates, 400)
    },
  },
  watch: {
    'filters.account': function (account) {
      this.page = 1
      this.filters.location = null
      if (account) {
        this.fetchLocations()
        this.fetchLocationStates()
        this.fetchLocationCities()
        this.fetchLocationAddresses()
        this.fetchLocationKeywords()
      }
    },
    'filters.states': function () {
      this.fetchLocationCities()
    },
    accounts: function (accounts) {
      if (!this.filters.account && accounts && Array.isArray(accounts.data)) {
        this.filters.account = accounts.data[0].name
        this.fetchReviews()
      }
    },
    page: function () {
      this.loadingSkeleton = true
      this.fetchReviews(true)
    },
  },
  created() {
    this.fetchAccounts()
  },
  destroyed() {
    this.$store.dispatch('locations/clearLocations')
  },
  data: () => ({
    loadingSkeleton: false,
    selectAll: false,
    moreFilters: false,
    timeoutLocations: null,
    timeoutStates: null,
    timeoutCities: null,
    timeoutAddress: null,
    timeoutKeywords: null,
    searchLocation: '',
    searchState: '',
    searchCity: '',
    searchAddress: '',
    searchKeyword: '',
    accountError: null,
    locationError: null,
    stateError: null,
    cityError: null,
    addressError: null,
    keywordsError: null,
    sortBy: '',
    loading: false,
    loadingAccounts: false,
    loadingLocations: false,
    loadingStates: false,
    loadingCities: false,
    loadingAddress: false,
    loadingKeywords: false,
    sortDesc: '',
    limit: 10,
    page: 1,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    filters: {
      star_rating: [],
      account: null,
      location: null,
      date_start: '',
      date_end: '',
      status: '',
      with_comment: null,
      with_reply: null,
      sort_by_stars: null,
      sort_by_date: null,
      city: '',
      states: [],
      address: '',
      keywords: [],
    },
    commentOptions: [
      { id: 1, text: 'Com comentário' },
      { id: 0, text: 'Sem comentário' },
    ],
    replyOptions: [
      { id: 1, text: 'Com resposta' },
      { id: 0, text: 'Sem resposta' },
    ],
    starRatingOptions: [
      { id: 1, text: '1' },
      { id: 2, text: '2' },
      { id: 3, text: '3' },
      { id: 4, text: '4' },
      { id: 5, text: '5' },
    ],
    orderDateOptions: [
      { id: 'desc', text: 'Mais recentes' },
      { id: 'asc', text: 'Menos recentes' },
    ],
    orderStarRatingOptions: [
      { id: 'desc', text: 'Mais estrelas' },
      { id: 'asc', text: 'Menos estrelas' },
    ],
  }),
}
</script>
